import MarkdownContent from './MarkdownContent';

export default MarkdownContent;
